import { useEffect } from "react";
import { useRootNavigationState, useRouter } from "expo-router";
import Drawer from "expo-router/drawer";

export default function Index() {
  const rootNavigationState = useRootNavigationState();
  const router = useRouter();

  useEffect(() => {
    if (rootNavigationState?.key) {
      router.replace("/(app)/home");
    }
  }, [rootNavigationState?.key, router]);

  return null;
}
